import formatDate from '@/services/general/formatIsoDate';
import calculArrondi from '@/services/calcul/calculArrondi';
import cloneDeep from 'lodash/cloneDeep';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';

export default function gestionLettrages(pieces, mouvementClientReglement, impacterAffecte,
  autoriserEscomptes) {
  if (pieces === null || mouvementClientReglement === null) return null;
  let lettragesReglement = [];
  let montantReglementRestantAAffecter = mouvementClientReglement.resteALettrer;

  if (mouvementClientReglement.lettrages !== null) {
    lettragesReglement = cloneDeep(mouvementClientReglement.lettrages);
  }
  if (mouvementClientReglement.mouvementClientEnfants !== undefined
    && mouvementClientReglement.mouvementClientEnfants !== null) {
    mouvementClientReglement.mouvementClientEnfants.forEach(mcEscompte => {
      if (mcEscompte.lettrages === undefined || mcEscompte.lettrages === null) return;
      mcEscompte.lettrages.forEach(lettrage => {
        lettragesReglement.push(cloneDeep(lettrage));
      });
    });
  }
  const nouveauxLettrages = [];

  pieces.forEach(piece => {
    let mouvementClientEscompte = null;
    let montantEscompte = piece.montantEscompte;
    if (piece.escompteApplicable === false || autoriserEscomptes === false) montantEscompte = 0.0;

    if (mouvementClientReglement.mouvementClientEnfants !== undefined
      && mouvementClientReglement.mouvementClientEnfants !== null
      && piece.pieceType === mouvementClientConf.FACTURE) {
      mouvementClientEscompte = mouvementClientReglement.mouvementClientEnfants.find(mcEscompte => {
        return mcEscompte.factureId === piece.pieceId;
      });
    }
    if (piece.mouvementsClients === null) return;
    piece.mouvementsClients.forEach(mcPiece => {
      let indexLettrageExistant = lettragesReglement.findIndex((lettrage) => {
        return (lettrage.mouvementClient1Id === mcPiece.id
          && lettrage.mouvementClient2Id === mouvementClientReglement.id)
          || (lettrage.mouvementClient2Id === mcPiece.id
            && lettrage.mouvementClient1Id === mouvementClientReglement.id);
      });
      mcPiece.escompteAffecte = Math.min(montantEscompte, mcPiece.inputAffecte);
      montantEscompte -= mcPiece.escompteAffecte;
      if (montantEscompte === 0.0 && mcPiece.inputAffecte === 0.0) return;
      if (montantReglementRestantAAffecter <= 0) return;
      const montantAffecteMvtClient = autoriserEscomptes ? mcPiece.inputAffecte
        : Math.min(mcPiece.inputAffecte, montantReglementRestantAAffecter);
      if (indexLettrageExistant === -1) {
        if (mcPiece.inputAffecte != null
          && parseFloat(calculArrondi(montantAffecteMvtClient - mcPiece.escompteAffecte)) !== 0) {
          nouveauxLettrages.push({
            id: null,
            dateLettrage: formatDate(new Date()),
            montant: parseFloat(calculArrondi(montantAffecteMvtClient - mcPiece.escompteAffecte)),
            mouvementClient1Id: mouvementClientReglement.id,
            mouvementClient2Id: mcPiece.id,
          });
          if (impacterAffecte !== undefined && impacterAffecte !== null && impacterAffecte) {
            mcPiece.inputAffecte -= parseFloat(calculArrondi(montantAffecteMvtClient
              - mcPiece.escompteAffecte));
          }
        }
      } else {
        const lettrageExistant = cloneDeep(lettragesReglement[indexLettrageExistant]);
        if (impacterAffecte !== undefined && impacterAffecte !== null && impacterAffecte) {
          lettrageExistant.montant += parseFloat(calculArrondi(montantAffecteMvtClient
            - mcPiece.escompteAffecte));
          mcPiece.inputAffecte -= parseFloat(calculArrondi(montantAffecteMvtClient
            - mcPiece.escompteAffecte));
        } else {
          lettrageExistant.montant = parseFloat(calculArrondi(montantAffecteMvtClient
            - mcPiece.escompteAffecte));
        }
        lettrageExistant.mouvementClient1Id = mouvementClientReglement.id;
        lettrageExistant.mouvementClient2Id = mcPiece.id;
        nouveauxLettrages.push(lettrageExistant);
        lettragesReglement.splice(indexLettrageExistant, 1);
      }
      montantReglementRestantAAffecter -= montantAffecteMvtClient;

      if (mouvementClientEscompte !== null
        && parseFloat(calculArrondi(mcPiece.escompteAffecte)) !== 0) {
        indexLettrageExistant = lettragesReglement.findIndex((lettrage) => {
          return (lettrage.mouvementClient1Id === mcPiece.id
            && lettrage.mouvementClient2Id === mouvementClientEscompte.id)
            || (lettrage.mouvementClient2Id === mcPiece.id
            && lettrage.mouvementClient1Id === mouvementClientEscompte.id);
        });
        if (indexLettrageExistant === -1) {
          nouveauxLettrages.push({
            id: null,
            dateLettrage: formatDate(new Date()),
            montant: parseFloat(calculArrondi(mcPiece.escompteAffecte)),
            mouvementClient1Id: mouvementClientEscompte.id,
            mouvementClient2Id: mcPiece.id,
          });
        } else {
          const lettrageExistant = cloneDeep(lettragesReglement[indexLettrageExistant]);
          lettrageExistant.montant = parseFloat(calculArrondi(mcPiece.escompteAffecte));
          lettrageExistant.mouvementClient1Id = mouvementClientEscompte.id;
          lettrageExistant.mouvementClient2Id = mcPiece.id;
          nouveauxLettrages.push(lettrageExistant);
          lettragesReglement.splice(indexLettrageExistant, 1);
        }
      }
    });
  });
  lettragesReglement.forEach(lettrage => {
    if (lettrage.id !== null && lettrage.montant !== null) {
      const lettrageExistant = cloneDeep(lettrage);
      nouveauxLettrages.push(lettrageExistant);
    }
  });

  return nouveauxLettrages;
}
